import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'

export const ReceiptTemplatesRoutes = [
  {
    path: '/receipt-templates',
    name: 'ListReceiptTemplates',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'receipt_template:list'
    }
  },
  {
    path: '/receipt-template/',
    name: 'CreateReceiptTemplate',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'receipt_template:create'
    }
  },
  {
    path: '/receipt-template/:id',
    name: 'UpdateReceiptTemplate',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'receipt_template:update'
    }
  }
]
